import {MODALITY} from '@domain/model/Account/Subscription/Subscription';

export const TEXT = {
  MODAL_TITLE: {id: 'account.currentLK.skip_title'},
  MODAL_DESCRIPTION: {id: 'account.currentLK.skip_subtitle'},
  MODAL_CTA: {id: 'account.currentLK.skip_cta1'},
  MODAL_CTA_CANCEL: {id: 'account.currentLK.skip_cta2'},
  TOAST_SUCCESS: {id: 'account.currentLK.skip_toast_success'},
  TOAST_ERROR: {id: 'account.currentLK.toast_error'},
} as const;

export const SKIP_MONTH = {
  [MODALITY.ON_DEMAND]: 0,
  [MODALITY.MONTHLY]: 1,
  [MODALITY.BIMONTHLY]: 2,
  [MODALITY.QUARTERLY]: 3,
} as const;

export const DATE_FORMAT = {
  month: 'long',
  day: '2-digit',
  weekday: 'long',
} as const;
